import { reportEvent } from '@stitch-fix/event-reporter/legacy';
import generateId from '@stitch-fix/log-weasel';
import packageInfo from '../../../../package.json';

const appName = packageInfo.name;

const trackProductEvent = ({
  eventName,
  canonicalName,
  actionType,
  actionName,
  actionDetail,
  directBuyContext,
  metricsTags,
}) => {
  const requestId = generateId(appName);

  const eventParams = {
    event_name: eventName,
    canonical_name: canonicalName,
    action_type: actionType,
    action_name: actionName,
    action_detail: actionDetail,
    additional_context: { direct_buy: directBuyContext },
    full_url: window.location.href,
    referer: document.referrer,
    source_app: appName,
    routing_key: 'sf.clients.product_tracking.event',
    metrics_tags: metricsTags || {},
  };

  reportEvent({
    event: eventParams,
    requestId,
  });
};

export default trackProductEvent;
